<div class="container" style="margin-top: 30px">
  <h4>
    <span class="material-icons"> local_shipping </span> Shipments on this order
  </h4>
  <hr />
  <table class="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Carrier</th>
        <th scope="col">Tracking Status</th>
        <th scope="col">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ship of shipments">
        <th scope="row">{{ ship.id }}</th>
        <td>{{ ship.carrierCode }}</td>
        <td>{{ ship.trackingStatus | Limpiarguion }}</td>
        <td>
          <button (click)="gotoship(ship.id)" class="btn btn-success">
            See details
          </button>
          <button
            (click)="openDialogAddItemsToBox(ship.id)"
            class="btn btn-info"
          >
            Add Items
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="shipments.length == 0" class="col-md-12 alert alert-info">
    There is no shipments on this order.
  </div>

  <!-- <loading *ngIf="loading"></loading> -->

  <h4 style="margin-top: 50px; margin-bottom: 20px">
    <span class="material-icons"> local_shipping </span> Create Shipping for
    this order
  </h4>

  <div class="row">
    <div
      class="col-md-6"
      style="border-color: whitesmoke; border-style: dashed; padding: 40px"
    >
      <h4 style="">Create new package</h4>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Type Service</label>
        <div class="col-md-9 col-9">
          <select
            [(ngModel)]="servicesCodeSelected"
            placeholder="Type Service"
            class="form-control"
            name="code"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="*">Please select an option</option>
            <option *ngFor="let value of servicesCodeShipping" [value]="value">
              {{ value }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Weight</label>
        <div class="col-md-9 col-9">
          <mat-form-field class="example-full-width">
            <input
              matInput
              type="text"
              name="sweightvalue"
              [(ngModel)]="shippingweightvalue"
              placeholder="Weight"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Unit</label>
        <div class="col-md-9 col-9">
          <select
            name="shipping_weight_unit"
            [(ngModel)]="shippingweightunit"
            placeholder="Type Service"
            class="form-control"
          >
            <option value="gram">Gram</option>
            <option value="kilogram">Kilogram</option>
            <option value="ounce">Ounce</option>
            <option value="pound">Pound</option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Dimensions Height</label>
        <div class="col-md-9 col-9">
          <mat-form-field class="example-full-width">
            <input
              matInput
              type="text"
              name="dimensions_heightvalue"
              [(ngModel)]="dimensionsheightvalue"
              placeholder="Dimensions Height"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Dimensions Width</label>
        <div class="col-md-9 col-9">
          <mat-form-field class="example-full-width">
            <input
              matInput
              type="text"
              name="dimensions_widthvalue"
              [(ngModel)]="dimensionswidthvalue"
              placeholder="Dimensions Width"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Dimensions Length</label>
        <div class="col-md-9 col-9">
          <mat-form-field class="example-full-width">
            <input
              matInput
              type="text"
              name="dimensions_lengthvalue"
              [(ngModel)]="dimensionslengthvalue"
              placeholder="Dimensions Length"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3 col-2 col-form-label">Dimensions Unit</label>
        <div class="col-md-9 col-9">
          <select
            name="shipping_dimensions_unit"
            [(ngModel)]="shippingdimensionsunit"
            placeholder="Type Service"
            class="form-control"
          >
            <option value="inch">Inch</option>
            <option value="centimeter">Centimeter</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <br>
          <mat-checkbox class="example-margin" name="add_insurance" [(ngModel)]="add_insurance">Add Insurance</mat-checkbox>
        </div>
      </div>
      <div class="row" *ngIf="add_insurance">
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <label >Insured Amount Per Box</label>
              <mat-form-field class="example-full-width">
                <input
                  matInput
                  type="number"
                  name="amount"
                  [(ngModel)]="insured_value_amount"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-6">

          <div class="row">
            <div class="col-12">
            <label>Currency</label>
          <select style="margin-top: 4px;"
              name="currency"
              [(ngModel)]="insured_value_currency"
              placeholder="Currency"
              class="form-control"
            >
              <option value="usd">USD</option>
            </select>
          </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <button
            style="margin-top: 20px"
            class="btn btn-success"
            (click)="addToPackage()"
          >
            Add Package
          </button>
        </div>
        <div class="col-9" style="text-align: right; margin-top: 20px;">
          <button mat-icon-button color="primary" style="font-size: 25px;" (click)="rem()">
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
          </button>
          &nbsp;&nbsp;&nbsp;
          <span style="font-size: 20px; font-weight: bolder;">{{pakageNum}}</span>
          &nbsp;&nbsp;&nbsp;
          <button mat-icon-button color="primary" style="font-size: 25px;" (click)="add()">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </button>
          &nbsp;&nbsp;&nbsp;
          <span style="font-size: 20px; font-weight: bolder;">Packages</span>
        </div>
      </div>

    </div>
    <div class="col-md-6" style="text-align: center">
      <button
        [disabled]="this.packages.length == 0"
        style="
          margin: 0 auto;
          height: 100px;
          font-size: large;
          font-weight: 900;
          font-weight: 800;
        "
        (click)="createShipment()"
        class="btn btn-success"
      >
        Create Shipment
      </button>

      <div
        style="margin-top: 10px"
        *ngIf="showmsgerrorshipping"
        class="alert alert-danger"
      >
        {{ messageErrorShip }}
      </div>

      <div style="margin-top: 20px">
        <h4 style="text-decoration: underline">{{packages.length}}x Packages ready to send:</h4>

        <div *ngFor="let item of packages">
          <span class="material-icons"> unarchive </span>
          {{ item.weight_value }} {{ item.weight_unit }}
        </div>
      </div>
    </div>
  </div>
</div>
